import { Route } from "./types";
import { createElement, lazy } from "react";
import {
  CREATE_MANAGE_USERS_PATH,
  CREATE_ORDER_QUOTE_PATH,
  EDIT_ORDER_QUOTE_PATH,
  ERROR_PATH,
  FORGOT_PASSWORD_EMAIL_PATH,
  FORGOT_PASSWORD_PATH,
  FORGOT_PASSWORD_SUCCESS_PATH,
  FORGOT_PASSWORD_UPDATE_PATH,
  HOME_PATH,
  LOGIN_PATH,
  LOGIN_VERIFICATION_PATH,
  MANAGE_USERS_PATH,
  ORDER_QUOTE_PATH,
  PROFILE_DETAILS_PATH,
  PROFILE_PASSWORD_PATH,
  PROFILE_PATH,
  WEB_STORE_REQUEST_PATH,
  WEB_STORE_REQUEST_ONLINE_PATH,
} from "./constants";

const loginPage = lazy(() => import('pages/Login'));
const otpPage = lazy(() => import('pages/Otp'));
const forgotPasswordPage = lazy(() => import('pages/ForgotPassword'));
const hauffSportsPage = lazy(() => import('pages/HauffSports'));
const profilePage = lazy(() => import('pages/Profile'));
const orderQuotesPage = lazy(() => import('contents/orders'));
const createOrderWrapperPage = lazy(() => import('contents/create-order/CreateOrderWrapper'));
const manageUsersPage = lazy(() => import('contents/manage-users'));
const webStoreRequestPage = lazy(() => import('contents/web-request-form'));
const createUserPage = lazy(() => import('contents/create-user'));
const userDetailsPage = lazy(() => import('contents/user-details'));
const changePasswordPage = lazy(() => import('contents/change-password'));
const redirectPage = lazy(() => import('pages/Redirect'));
const forgotPasswordUpdatePage = lazy(() => import('pages/ForgotPassword/ForgotPasswordUpdate'));
const forgotPasswordSuccessPage = lazy(() => import('pages/ForgotPassword/ForgotPasswordSuccess'));
const forgotPasswordFormPage = lazy(() => import('pages/ForgotPassword/ForgotPasswordForm'));
const webStoreRequestOnlinePage = lazy(() => import('pages/WebStoreRequest'));

export const mainRoutes: Route[] = [
  {
    name: "Login",
    path: LOGIN_PATH,
    children: [
      {
        element: createElement(loginPage),
        index: true,
      },
      {
        path: LOGIN_VERIFICATION_PATH,
        element: createElement(otpPage),
        index: false,
      },
    ],
  },
  {
    name: "Forgot Password",
    path: FORGOT_PASSWORD_PATH,
    children: [
      {
        element: createElement(redirectPage, { path: FORGOT_PASSWORD_EMAIL_PATH }),
        index: true,
      },
      {
        path: "*",
        element: createElement(forgotPasswordPage),
        index: false,
      },
    ],
  },
  {
    name: "Home",
    path: HOME_PATH,
    children: [
      {
        element: createElement(hauffSportsPage),
        index: true,
      },
      {
        path: "*",
        element: createElement(hauffSportsPage),
        index: false,
      },
    ],
  },
  {
    name: "Profile",
    path: PROFILE_PATH,
    children: [
      {
        element: createElement(redirectPage, { path: PROFILE_DETAILS_PATH }),
        index: true,
      },
      {
        path: "*",
        element: createElement(profilePage),
        index: false,
      },
    ],
  },
  {
    name: "Web Store Request Online",
    path: WEB_STORE_REQUEST_ONLINE_PATH,
    children: [
      {
        element: createElement(webStoreRequestOnlinePage),
        index: true,
      },
    ],
  },
];

export const moduleRoutes: Route[] = [
  {
    name: "Order Quotes",
    path: ORDER_QUOTE_PATH,
    children: [
      {
        element: createElement(orderQuotesPage),
        index: true,
      },
      {
        path: CREATE_ORDER_QUOTE_PATH,
        element: createElement(createOrderWrapperPage),
        index: false,
      },
      {
        path: EDIT_ORDER_QUOTE_PATH,
        element: createElement(createOrderWrapperPage),
        index: false,
      },
    ],
  },
  {
    name: "Manage Users",
    path: MANAGE_USERS_PATH,
    children: [
      {
        element: createElement(manageUsersPage),
        index: true,
      },
      {
        path: CREATE_MANAGE_USERS_PATH,
        element: createElement(createUserPage),
        index: false,
      },
    ],
  },
  {
    name: "Web Store Request",
    path: WEB_STORE_REQUEST_PATH,
    children: [
      {
        element: createElement(webStoreRequestPage),
        index: true,
      }
    ],
  },
];

export const profileModuleRoutes: Route[] = [
  {
    name: "User Details",
    path: PROFILE_DETAILS_PATH,
    children: [
      {
        element: createElement(userDetailsPage),
        index: true,
      },
    ],
  },
  {
    name: "Change Password",
    path: PROFILE_PASSWORD_PATH,
    children: [
      {
        element: createElement(changePasswordPage),
        index: true,
      },
    ],
  },
];

export const forgotPasswordRoutes: Route[] = [
  {
    name: "Forgot Password Email",
    path: FORGOT_PASSWORD_EMAIL_PATH,
    element: createElement(forgotPasswordFormPage),
  },
  {
    name: "Update Password",
    path: FORGOT_PASSWORD_UPDATE_PATH,
    element: createElement(forgotPasswordUpdatePage),
  },
  {
    name: "Forgot Password Success",
    path: FORGOT_PASSWORD_SUCCESS_PATH,
    element: createElement(forgotPasswordSuccessPage),
  },
];

export const errorRoutes: Route = {
  name: "error",
  path: ERROR_PATH,
};
